import { useRoute } from 'shared/src/hooks/useRoute';
import type { HomeStackParamList } from '../Navigator';

export const useHomeRoute = <Key extends keyof HomeStackParamList>() =>
  useRoute<HomeStackParamList, Key>();
